module.exports = __webpack_public_path__ + "img/cases01-bg.068cc673.png";